import { uuidToBase58 } from '@cumu/shared';
import { controller, target } from '@github/catalyst';
import type { Attachment } from '@github/file-attachment-element';
import { uploadAttachments } from '../../attachments';
import { getLocale } from '../../locale';

@controller('pdf-template-upload')
export class PdfTemplateUploadElement extends HTMLElement {
  @target declare fileInput: HTMLInputElement;

  async fileAttachmentAccepted(
    event: CustomEvent<{ attachments: Attachment[] }>
  ) {
    const uploadHref = this.getAttribute('upload-href');
    if (!uploadHref) {
      throw new Error('Missing upload href');
    }
    const uploadUrl = new URL(uploadHref, location.origin);
    const locale = getLocale();
    const attachments = event.detail.attachments;
    try {
      this.fileInput.disabled = true;
      this.fileInput.labels?.forEach(label => label.classList.add('btn-busy'));
      await uploadAttachments({
        locale,
        attachments,
        uploadUrl,
        attachmentSaved: ({ id }) => {
          const copyTemplateId = this.getAttribute('copy-template-id');
          const params = new URLSearchParams();
          if (copyTemplateId) {
            params.set('copy_template_id', copyTemplateId);
          }
          if (this.hasAttribute('delete-original')) {
            params.set('delete_original', 'true');
          }
          const { origin, pathname } = location;
          location.href = `${origin}${pathname.substr(0, pathname.indexOf('/pdf-templates') + '/pdf-templates'.length)}/${uuidToBase58(id!)}?${params}`;
        }
      });
    } finally {
      this.fileInput.disabled = false;
      this.fileInput.labels?.forEach(label =>
        label.classList.remove('btn-busy')
      );
    }
  }
}
